module.exports = __webpack_public_path__ + "media/assets/images/icon-hamburger-67a4b875003c2c53616730c3d2e2f96a.svg";